import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { StartPageSearchResults } from 'src/app/core/interfaces/start-page-search-results.interface';
import { AppInterface, ClickOnAppBehavior } from "../../../../interfaces/app.interface";
import { LogEventService } from "../../../../services/log-event-service/log-event.service";
import { ApplicationSearchResultComponent } from './components/application-search-result/application-search-result.component';
import { BookmarkSearchResultComponent } from './components/bookmark-search-result/bookmark-search-result.component';

@Component({
  selector: 'start-page-result',
  imports: [ApplicationSearchResultComponent, BookmarkSearchResultComponent, TranslatePipe],
  templateUrl: './start-page-result.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./start-page-result.component.scss'],
})
export class StartPageResultComponent {
  @Input() searchResults!: StartPageSearchResults;

  constructor(private logEventService: LogEventService) {}

  logAppSearchResult(app: AppInterface): void {
    this.logEventService.logServer('app', 'searchResult', app.appId + '');
  }

  logBookmarkResult(app: AppInterface): void {
    this.logEventService.logServer('bookmark', 'searchResult', app.appInstanceId);
  }

  protected readonly ClickOnAppBehavior = ClickOnAppBehavior;
}
